import apiClient from "../client";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface LeadPayload {
  name: string;
  email: string;
  mobile: string;
  region: string;
  category: string;
  product: string;
  message: string;
}

export const submitLead = async (payload: LeadPayload) => {
  const { data } = await apiClient.post(`${API_BASE_URL}/intron/lead/`, payload);
  return data;
};
